// Clinic Configuration for Dentist In Concord
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Dentist In Concord",
  clinicId: "dentistinconcord",
  clinicUrl: "https://dentistinconcord.com",

  // Contact Information
  phoneNumber: "(704) 707-3620",
  phoneNumberRaw: "+17047073620", // For tel: and sms: links
  email: "DentalCare@DentistinConcord.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=dentistinconcord&agentId=e9b4a243-4dc4-4fe0-932e-83ba7df63c71",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/dentistinconcord/voice",
  // Location
  address: "2460 Wonder Drive Northeast C, Kannapolis, NC 28083, United States",
  addressShort: "2460 Wonder DR STE C, Kannapolis, NC 28083",
  city: "Concord",
  hcity: "concord",
  state: "North Carolina",
  stateShortForm: "NC",
  PostalCode: "28083",
  // Map Links
  mapUrl: "https://maps.app.goo.gl/ojkQEt4xd8oUQTtXA",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d9901.10653336971!2d-80.58971700000001!3d35.464846!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88540931f6603dfd%3A0x6d61ad0134d3d71e!2sDentist%20in%20Concord!5e1!3m2!1sen!2sin!4v1759820552807!5m2!1sen!2sin',
  iframeTitle: "Dentist in Concord",

  //membership
  membership: "https://member.clerri.com/?slug=BR4P",

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/DentistinConcord",

  // Cherry
  cherryUrl: "https://pay.withcherry.com/dentist-in-concord?utm_source=practice&utm_medium=email&m=65975",


  // Analytics
  gaMeasurementId: "G-2RPRLHR8VL",
  clarityProjectId: "prd9vboz9f",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/dentistinconcord",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/dentistinconcord",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/dentistinconcord",
  patientRegistrationUrl: "https://apig.todaysdentalinsights.com/patient-registration/public/dentistinconcord",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://dentistinconcord.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/DentistinConcord",
    instagram: "https://www.instagram.com/dentistinConcord/",
    twitter: "https://x.com/Dent_Concord",
    linkedin: "https://www.linkedin.com/company/108117805/admin/?lipi=urn%3Ali%3Apage%3Ad_flagship3_feed%3BZHzZHS4UQLaEyel%2BGoze8g%3D%3D",
    youtube: "https://www.youtube.com/@Dentistinconcord",
  },

  // Review Links (for Patient Reviews page)
  reviewLinks: {
    google: "https://business.google.com/n/378706828007186846/profile?hl=en-GB&fid=7881771043567949598",
    facebook: "https://www.facebook.com/dentistinconcord.official/",
    yelp: "https://www.yelp.com/biz/dentist-in-concord-kannapolis",
  },

  // Open Dental Configuration
  defaultProvNum: 6,
  defaultOpNum: 17,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: "New patient emergency/other",
      label: "New patient emergency/other",
      duration: 30,
      opNum: 18,
      AppointmentTypeNum: 10,
    },
    {
      value: "Existing patient emergency/other",
      label: "Existing patient emergency/other",
      duration: 30,
      opNum: 17, // DEFAULT_OP_NUM
      AppointmentTypeNum: 2,
    },
    {
      value: "Existing patient current treatment Plan",
      label: "Existing patient current treatment Plan",
      duration: 30,
      opNum: 17, // DEFAULT_OP_NUM
      AppointmentTypeNum: 6,
    },
  ],


  // Twilio Configuration
  twilioPhoneNumber: "19802528659",

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:+${this.twilioPhoneNumber}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  reviewLinks,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;

